module.exports = __webpack_public_path__ + "img/Mychecklist.db4ca6a8.png";